<template>
  <div
      v-bind:key="automationResult.id"
      class="automation-result-row row bottom-border flex-row align-items-center signalRow"
      style="position: relative"
  >
    <div class="col-md-1">
      <a-checkbox v-if="canBeProcessed(automationResult)"
                  v-bind:checked="isSelected" v-on:input="onCheckboxChange"/>
      <a-checkbox v-else v-bind:checked="false" v-bind:disabled="true" style="opacity:0.5;"/>
    </div>
    <div v-if="showAutomation" class="col-md-3"><p>{{ automationResult.title }}</p></div>
    <div :class="[showAutomation ? 'col-md-3' : 'col-md-3']">
      <p>
        <customer-badge-component v-if="hasCustomer" :link="false" size="small"
                                  :customer="customer"></customer-badge-component>
      </p>
    </div>
    <div :class="[showAutomation ? 'col-md-2' : 'col-md-3']"><p>{{ date(automationResult) }}</p></div>
    <div :class="[showAutomation ? 'col-md-2' : 'col-md-2']"><p>{{ time(automationResult) }}</p></div>
    <div :class="[showAutomation ? 'col-md-2' : 'col-md-3']">
      <p v-if="hasProcessedByUser">
        Verwerkt door
        <user-badge v-bind:user="processedByUser" size="small"/>
      </p>
      <p v-else-if="isAutomationResultProcessing(automationResult)">
        Wordt verwerkt
      </p>
      <p v-else-if="isAutomationResultProcessed(automationResult)">
        Is verwerkt
      </p>
      <p v-if="hasIgnoredByUser">
        Geannuleerd door
        <user-badge v-bind:user="ignoredByUser" size="small"/>
      </p>
      <div v-if="canBeProcessed(automationResult)" class="flex-row align-items-center"
           style="margin-top: 8px; margin-bottom: 8px">
        <div class="c_btn btn_verify" :ref="automationResult.id"
             @click="onProcessClick(automationResult)">
          <CheckBold title="Goedkeuren" class="color-white icon-size-md"/>
        </div>
        <div class="c_btn btn_cancel" :ref="automationResult.id"
             @click="ignoreAutomationResult(automationResult)">
          <CloseThick title="Afkeuren" class="color-white icon-size-md"/>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
import { Skeleton } from 'vue-loading-skeleton'
import { mapActions, mapGetters } from 'vuex'
import store from '~/pages/automation/store'
import EmailCheckOutline from 'vue-material-design-icons/EmailCheckOutline.vue'
import CloseThick from 'vue-material-design-icons/CloseThick.vue'
import CheckBold from 'vue-material-design-icons/CheckBold.vue'
import CustomerBadgeComponent from '~/modules/customer/components/BadgeComponent.vue'

export default {
  name: 'AutomationResultRowComponent',
  components: {
    CustomerBadgeComponent,
    CheckBold,
    CloseThick,
    EmailCheckOutline,
    Skeleton
  },
  props: {
    automationResult: {
      type: Object,
      required: true,
    },
    showAutomation: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      infoColorClass: '',
    }
  },
  mounted () {
    const STORE_KEY = '$_automation'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  computed: {
    ...mapGetters({
      selectedAutomationResults: '$_automation/selectedAutomationResults',
    }),
    hasCustomer () {
      return this.automationResult.customer !== null
        && this.automationResult.customer !== undefined
        && this.automationResult.customer.data !== null
        && this.automationResult.customer.data !== undefined
    },
    customer () {
      return this.automationResult.customer.data
    },
    hasProcessedByUser () {
      return this.automationResult.processed_by_user !== null
        && this.automationResult.processed_by_user !== undefined
        && this.automationResult.processed_by_user.data !== null
        && this.automationResult.processed_by_user.data !== undefined
    },
    processedByUser () {
      return this.automationResult.processed_by_user.data
    },
    hasIgnoredByUser () {
      return this.automationResult.ignored_by_user !== null
        && this.automationResult.ignored_by_user !== undefined
        && this.automationResult.ignored_by_user.data !== null
        && this.automationResult.ignored_by_user.data !== undefined
    },
    ignoredByUser () {
      return this.automationResult.ignored_by_user.data
    },
    isSelected () {
      return this.selectedAutomationResults.find((ar) => ar.id === this.automationResult.id) !== undefined
    },
  },
  methods: {
    ...mapActions({
      selectAutomationResult: '$_automation/selectAutomationResult',
      deselectAutomationResult: '$_automation/deselectAutomationResult',
      isAutomationResultSelected: '$_automation/isAutomationResultSelected',
      manuallyProcessAutomationResult: '$_automation/manuallyProcessAutomationResult',
      ignoreAutomationResult: '$_automation/ignoreAutomationResult',
    }),
    date (automationResult) {
      return moment(automationResult.created_at)
        .format('DD-MM-YYYY')
    },
    time (automationResult) {
      return moment(automationResult.created_at)
        .format('HH:mm')
    },
    isAutomationResultProcessed (automationResult) {
      return automationResult.processed_at !== null
        || automationResult.ignored_at !== null
    },
    isAutomationResultProcessing (automationResult) {
      return automationResult.processed_at === null
        && automationResult.ignored_at === null
        && automationResult.process_started_at !== null
    },
    canBeProcessed (automationResult) {
      return !this.isAutomationResultProcessed(automationResult)
        && !this.isAutomationResultProcessing(automationResult)
    },
    onProcessClick (automationResult) {
      this.manuallyProcessAutomationResult(automationResult)
    },
    onCheckboxChange (value) {
      if (value) {
        this.selectAutomationResult(this.automationResult)
      } else {
        this.deselectAutomationResult(this.automationResult)
      }
    },
  },
}
</script>
<style scoped lang="scss">
.automation-configure-signal-settings-component {
  position: relative;

  .ant-select {
    width: 100% !important;
    display: block !important;
  }
}
</style>
